import { Box } from '@mui/material';
import Text from 'components/Text';
import { usePrismaticEmbed } from 'hooks/usePrismaticEmbed';

interface PrismaticEmbedProps {
  embedFunction: (organizationId: string, selector: string) => Promise<void>;
  containerId: string;
}

export const PrismaticEmbed = ({
  embedFunction,
  containerId
}: PrismaticEmbedProps) => {
  const { containerRef, error } = usePrismaticEmbed({
    embedFunction,
    containerId
  });

  return (
    <Box display="flex" flexDirection="column" height="100%">
      {error && (
        <Box mb={2}>
          <Text variant="body" color="error">
            {error}
          </Text>
        </Box>
      )}
      <Box flex={1} position="relative" minHeight="600px">
        <div
          ref={containerRef}
          id={containerId}
          style={{ height: '100%', width: '100%' }}
        />
      </Box>
    </Box>
  );
};
